export default "__VITE_ASSET__bIiJMC_m__"